var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#102A56",
  d: "M1.875 5c0-.345.28-.625.625-.625h15a.625.625 0 0 1 0 1.25h-15A.625.625 0 0 1 1.875 5M17.5 9.375h-15a.625.625 0 0 0 0 1.25h15a.625.625 0 0 0 0-1.25m0 5h-15a.625.625 0 0 0 0 1.25h15a.625.625 0 0 0 0-1.25"
})));
export default SvgMenu;